import { chakra } from "@chakra-ui/react";
import { Link as RouterLink } from "react-router-dom";

const CTA = ({ to, children, variant = "primary" }) => {
    const styles = {
        primary: {
            fontWeight: "medium",
            color: "brand.green.500",
            _hover: { textDecoration: "underline", color: "brand.green.600" },
        },
        secondary: {
            fontSize: "sm",
            color: "gray.600",
            _hover: { textDecoration: "underline", color: "brand.blue.700" },
        },
    };

    return (
        <chakra.span
            as={RouterLink}
            to={to}
            {...styles[variant]}
        >
            → {children}
        </chakra.span>
    );
};

export default CTA;
